export const SEO_CONTENT = {
  en: {
    home: {
      title: 'Run for M.E. - Running to raise awareness for M.E.',
      description: 'Join us in running various runs to raise awareness and funds for M.E. (Myalgic Encephalomyelitis). Every step brings us closer to understanding this devastating illness.',
      keywords: 'M.E., Myalgic Encephalomyelitis, CFS, Chronic Fatigue Syndrome, what is me, what is M.E., me/cfs, myalgic encephalomyelitis, chronic fatigue, post-exertional malaise, marathon fundraiser, Cologne Marathon, research funding, patient support, awareness campaign, neurological illness, immune system disorder, long covid, ME/CFS research',
      type: 'website' as const,
    },
    meInfo: {
      title: 'What is M.E.? - Understanding Myalgic Encephalomyelitis | Run for M.E.',
      description: 'Learn about M.E. (Myalgic Encephalomyelitis), a complex neuroimmunological illness affecting 71 million people worldwide. Understand symptoms, impact, and why research funding is crucial.',
      keywords: 'M.E., Myalgic Encephalomyelitis, CFS, Chronic Fatigue Syndrome, what is me, what is M.E., me/cfs, myalgic encephalomyelitis, symptoms, neuroimmunological illness, post-exertional malaise, PEM, research funding, patient support, neurological disorder, immune system, chronic illness, debilitating disease, ME/CFS symptoms, brain fog, muscle pain, sleep problems, orthostatic intolerance',
      type: 'article' as const,
    },
    timeline: {
      title: 'Runs - Participating in Various Runs for M.E. | Run for M.E.',
      description: 'We participate in various runs to raise awareness and funds for M.E. See our upcoming races including Rome, Hamburg, Bonn, Cologne, and Munich.',
      keywords: 'running events, marathon runs, half marathon, M.E. research, run for me, charity runs, fundraising runs, M.E. awareness, running fundraiser, Rome Marathon, Hamburg Marathon, Cologne Marathon, Munich Marathon, Bonn Marathon',
      type: 'website' as const,
    },
    about: {
      title: 'About Us - Run for M.E. Team | Marathon Fundraiser',
      description: 'Meet the Run for M.E. team dedicated to raising awareness and funds for M.E. Learn about our mission to support those affected by this devastating illness.',
      keywords: 'Run for M.E. team, marathon runners, M.E. awareness, fundraising mission, patient support, run for me team, M.E. advocates, charity runners, awareness campaign',
      type: 'website' as const,
    },
    mitmachen: {
      title: 'Get Involved - Contact & Join | Run for M.E.',
      description: 'Get involved with Run for M.E. Contact us by email or follow us on Instagram for training updates, M.E. awareness, and how to join our runs.',
      keywords: 'get involved, contact, join run for me, M.E. awareness, email, Instagram, marathon, run for me contact, participate',
      type: 'website' as const,
    },
    donate: {
      title: 'Donate - Support M.E. | Run for M.E.',
      description: 'Your donation directly supports M.E. We run various runs to raise awareness and funds. Help us make a difference in the lives of millions affected by this devastating illness.',
      keywords: 'donate, M.E. research funding, patient support, charity donation, medical research, run for me donate, M.E. charity, research donation, patient care funding, ME/CFS research funding',
      type: 'website' as const,
    },
    impressum: {
      title: 'Legal Notice - Run for M.E. | Impressum',
      description: 'Legal information and contact details for the Run for M.E. website.',
      keywords: 'legal notice, impressum, contact information, legal information, run for me legal',
      type: 'website' as const,
    },
    privacy: {
      title: 'Privacy Policy - Run for M.E. | Data Protection',
      description: 'Privacy policy and data protection information for the Run for M.E. website. Learn how we handle your data.',
      keywords: 'privacy policy, data protection, GDPR, personal data, run for me privacy',
      type: 'website' as const,
    },
    cookies: {
      title: 'Cookie Policy - Run for M.E. | Cookie Information',
      description: 'Information about cookies used on the Run for M.E. website and how to manage them.',
      keywords: 'cookie policy, cookies, website cookies, cookie management, run for me cookies',
      type: 'website' as const,
    },
  },
  de: {
    home: {
      title: 'Run for M.E. - Laufen für Aufklärung für M.E.',
      description: 'Lauf mit uns bei verschiedenen Läufen, um Aufmerksamkeit und Spenden für M.E. (Myalgische Enzephalomyelitis) zu sammeln. Jeder Schritt bringt uns dem Verständnis dieser verheerenden Erkrankung näher.',
      keywords: 'M.E., Myalgische Enzephalomyelitis, CFS, Chronisches Erschöpfungssyndrom, was ist me, was ist M.E., me/cfs, myalgische enzephalomyelitis, chronische erschöpfung, post-exertionale verschlechterung, Laufen für Aufklärung, Kölner Marathon, Forschungsförderung, Betroffenenhilfe, Aufklärungskampagne, neurologische erkrankung, immunsystem-störung, long covid, ME/CFS forschung',
      type: 'website' as const,
    },
    meInfo: {
      title: 'Was ist M.E.? - Verständnis von Myalgischer Enzephalomyelitis | Run for M.E.',
      description: 'Erfahre mehr über M.E. (Myalgische Enzephalomyelitis), eine komplexe neuroimmunologische Erkrankung, die weltweit 71 Millionen Menschen betrifft. Versteh Symptome, Auswirkungen und warum Forschungsförderung entscheidend ist.',
      keywords: 'M.E., Myalgische Enzephalomyelitis, CFS, Chronisches Erschöpfungssyndrom, was ist me, was ist M.E., me/cfs, myalgische enzephalomyelitis, symptome, neuroimmunologische erkrankung, post-exertionale verschlechterung, PEM, forschungsförderung, betroffenenhilfe, neurologische störung, immunsystem, chronische erkrankung, schwächende krankheit, ME/CFS symptome, gehirnnebel, muskelschmerzen, schlafprobleme, orthostatische intoleranz',
      type: 'article' as const,
    },
    timeline: {
      title: 'Läufe - Teilnahme an verschiedenen Läufen für M.E. | Run for M.E.',
      description: 'Wir nehmen an verschiedenen Läufen teil, um Aufklärung und Spenden für M.E. zu sammeln. Sieh dir unsere bevorstehenden Rennen an, einschließlich Rom, Hamburg, Bonn, Köln und München.',
      keywords: 'laufveranstaltungen, marathon läufe, halbmarathon, M.E. run for me, wohltätigkeitsläufe, fundraising läufe, M.E. aufklärung, rom marathon, hamburg marathon, köln marathon, münchen marathon, bonn marathon',
      type: 'website' as const,
    },
    about: {
      title: 'Über uns - Run for M.E. Team | Laufen für Aufklärung für M.E.',
      description: 'Lern das Run for M.E. Team kennen, das sich der Aufklärung und Sammlung von Spenden für M.E. widmet. Erfahre mehr über unsere Mission, Betroffene dieser verheerenden Erkrankung zu unterstützen.',
      keywords: 'Run for M.E. Team, Marathonläufer, M.E. Aufklärung, Fundraising Mission, run for me team, M.E. befürworter, wohltätigkeitsläufer, aufklärungskampagne',
      type: 'website' as const,
    },
    mitmachen: {
      title: 'Mitmachen - Kontakt & Mitmachen | Run for M.E.',
      description: 'Mach mit bei Run for M.E. Kontaktiere uns per E-Mail oder folge uns auf Instagram für Trainings-Updates, M.E.-Aufklärung und wie du bei unseren Läufen mitmachen kannst.',
      keywords: 'mitmachen, kontakt, run for me kontakt, M.E. aufklärung, e-mail, instagram, marathon, teilnehmen',
      type: 'website' as const,
    },
    donate: {
      title: 'Spenden - Unterstütze M.E. | Run for M.E.',
      description: 'Deine Spende unterstützt direkt M.E. Forschung und Patientenversorgungsprogramme. Wir laufen verschiedene Läufe, um Aufklärung zu betreiben und Spenden zu sammeln. Hilf uns, einen Unterschied im Leben von Millionen Betroffener dieser verheerenden Erkrankung zu machen.',
      keywords: 'spenden, M.E. run for me, Wohltätigkeitsspende, medizinische Forschung, run for me spenden, M.E. wohltätigkeit, forschungsspende, patientenversorgung förderung, ME/CFS forschungsförderung',
      type: 'website' as const,
    },
    impressum: {
      title: 'Impressum - Run for M.E. | Rechtliche Informationen',
      description: 'Rechtliche Informationen und Kontaktdaten für die Run for M.E. Website.',
      keywords: 'impressum, rechtliche Informationen, kontaktinformationen, rechtliche hinweise, run for me rechtlich',
      type: 'website' as const,
    },
    privacy: {
      title: 'Datenschutzerklärung - Run for M.E. | Datenschutz',
      description: 'Datenschutzerklärung und Datenschutzinformationen für die Run for M.E. Website. Erfahren Sie, wie wir mit Ihren Daten umgehen.',
      keywords: 'datenschutzerklärung, datenschutz, DSGVO, persönliche daten, run for me datenschutz',
      type: 'website' as const,
    },
    cookies: {
      title: 'Cookie-Erklärung - Run for M.E. | Cookie-Informationen',
      description: 'Informationen über auf der Run for M.E. Website verwendete Cookies und deren Verwaltung.',
      keywords: 'cookie-erklärung, cookies, website-cookies, cookie-verwaltung, run for me cookies',
      type: 'website' as const,
    },
  },
};
